


if (window.location.pathname === '/collections/all') {
      window.location = '/';
}

class NA {
  constructor() {
 //   HTMLElement.prototype.scrollIntoView = function () {};
    this.omniVariantChange(document);
  }

  htmlDecode(input) {
    var doc = new DOMParser().parseFromString(input, 'text/html');
    return doc.documentElement.textContent;
  }

  decodeElements(cls) {
    const metafields = document.getElementsByClassName(cls);
    if (typeof metafields == undefined || metafields == null || metafields.length == 0) {
      return;
    }
    for (var i = 0; i < metafields.length; i++) {
      const src = metafields[i].innerHTML;
      if (src === 'empty') {
        metafields[i].parentNode.parentNode.parentNode.hidden = true;
      } else {
        metafields[i].innerHTML = this.htmlDecode(src);
      }
    }
    //this.calculateProductVariantUnitPrices();
  }




omniVariantChange(html) {

  const omni_price = html.getElementsByClassName('omni-price-data')[0];
  const omni = document.getElementById('omni');
  if (!omni) return;

  const json = omni_price?.dataset?.price;
  const onsale = omni_price?.dataset?.onsale;
  if (json == undefined || json == '' || onsale == 'false') { 
    omni.innerHTML = '';
    return;
  }
  const amount = Number(JSON.parse(json).amount);
  const amount_with_comma = amount.toFixed(2).replace('.', ',');
  const var_id = omni_price.dataset.variant_id;

  
  omni.innerHTML = 'Alin 30 päivän hinta: ' + amount_with_comma + " €";
  

}

calculateProductVariantUnitPrices() {
    // Select all elements with class 'variant_unit_price'
    document.querySelectorAll('.variant_unit_price').forEach(function(element) {
        var variant_unit_price,
            variant_unit_type = element.getAttribute('data-variant_unit_type'),
            variant_unit_pcs = parseFloat(element.getAttribute('data-variant_pcs')),
            variant_price = parseFloat(element.getAttribute('data-variant_price').replace(',', '.').slice(0, -1));

        if (variant_unit_pcs > 0 && variant_price > 0 && typeof variant_unit_type === 'string') {
            switch (variant_unit_type) {
                case 'g':
                    variant_unit_type = 'kg';
                    variant_unit_price = (variant_price / variant_unit_pcs) * 1000.0;
                    break;
                case 'ml':
                    variant_unit_type = 'l';
                    variant_unit_price = (variant_price / variant_unit_pcs) * 1000.0;
                    break;
                case 'fol':
                    variant_unit_type = 'kpl';
                    variant_unit_price = variant_price / variant_unit_pcs;
                    break;
                default:
                    variant_unit_price = variant_price / variant_unit_pcs;
                    break;
            }

            element.textContent = '(yksikköhinta ' + variant_unit_price.toFixed(2).replace('.', ',') + element.getAttribute('data-variant_price').slice(-1) + ' / ' + variant_unit_type + ')';
        }
    });
}

  unitPriceChange(html) {
    const destination_unit_price_block = document.querySelector('.variant_unit-price-container');
    const source_unit_price_block = html.querySelector('.variant_unit-price-container');
    if (source_unit_price_block && destination_unit_price_block) {
      destination_unit_price_block.innerHTML = source_unit_price_block.innerHTML;
      //this.calculateProductVariantUnitPrices();
    }
  }

  speedDeliveryBadgeChange(html) {
    const badge = document.querySelector('#speed_delivery_badge');
    const speed = html.getElementById('speed_delivery').value;

    if (speed == 'true') {
      badge.style.display = 'flex';
    } else {
      badge.style.display = 'none';
    }
  }

  fixAddButton(dataset) {
    const productForm = document.getElementById(`product-form-${dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.addToCart;
  }

  variantChange(dataset, html) {
    //console.log('variantChange');
    //console.log(dataset);
    //console.log(html);
    const btn = document.getElementById('btnTxt');
    if (btn) {
      window.variantStrings.addToCart = btn.getAttribute('data');
      this.fixAddButton(dataset);
    }
    
    this.unitPriceChange(html);
    this.speedDeliveryBadgeChange(html);
    this.omniVariantChange(html);
 
    /*
    document.querySelectorAll(".product-form__input input[type='radio']").forEach((el) => {
      const label = el.nextElementSibling;
      label.setAttribute('style', 'border: 1px solid red;');
    });
    */
  
  }

  suomifi() {
    console.log('giosg - suomifi');
    (function suomiFiOpener(winParams) {
      window.open(
        "https://suomifi.giosg.app/auth/login?identifier=" +
          encodeURIComponent(giosg.unpackedVisitorCid + ":" + giosg.domainRoomId) 
          + "&" +
          Object.keys(winParams)
            .map(function (key) {
              return key + "=" + winParams[key];
            })
            .join("&"),
        "_top"
      );
    })({
      //configuration Id (for either testing or production) from Suomi.fi giosg app 
      config_id: "2eeb2277-709b-430c-9f7b-53f647fdb03d",
      referrer_url: document.location.href.split("#")[0],
      act_behalf: false,
      locale: 'fi'
    });
  }

setSessionStorageWithExpiry(key, value = true, hoursToExpire = 24) {
    const now = new Date().getTime();
    const expiryTime = now + hoursToExpire * 3600000; // Convert hours to milliseconds

    const item = {
        value: value,
        expiryTime: expiryTime
    };

    sessionStorage.setItem(key, JSON.stringify(item));
}

 getSessionStorageWithExpiry(key) {
    const itemStr = sessionStorage.getItem(key);

    if (!itemStr) {
        return null;
    }

    let item = null;

    try {
      item = JSON.parse(itemStr);      
    } catch (error) {
      sessionStorage.removeItem(key);
      return null;
    }

    const now = new Date().getTime();

    if (now > item.expiryTime) {
        sessionStorage.removeItem(key);
        return null;
    }

    return item.value;
}

  
  setUserTags() {

    
    if (this.getSessionStorageWithExpiry('user_tags') == 'true') {
      const btn = document.getElementById("form_btn_action_text");
      btn.innerHTML = "Ikätieto tallennettu";
      btn.setAttribute('disabled', 'true');
      return;
    }

    document.getElementById("form_btn_action_text").innerHTML = "Odotetaan tunnistetietoja..";

    // if giosg not ready run loadAll(0)
    if (typeof giosg == 'undefined') {
      document.getElementById("form_btn_action_text").innerHTML = "Odotetaan tunnistetietoja...";
      console.log('setUserTags - giosg not ready');
      na.loadAll(0);
      setTimeout(function () {
        na.setUserTags();
      }, 500);
      return;
    }

    document.getElementById("form_btn_action_text").innerHTML = "Odotetaan tunnistetietoja....";

    const room_id = giosg?.domainRoomId;
    const visitor_id = giosg?.unpackedVisitorCid;
    const customer_id = document.getElementById("customerId")?.value;
    if (!customer_id) return;
    if (!room_id || !visitor_id) {
      console.log('Not ready yet');
      // run again in 5 seconds
      setTimeout(function () {
        na.setUserTags();
      }, 5000);
      return;
    }
    
    const js = [room_id, visitor_id, customer_id];
    const t = btoa(JSON.stringify(js));
    const token = t[0] + t;
    const u = `https://na-chat-integration.azurewebsites.net/api/over18?token=${token}`;
    //console.log(u);
    // fetch u no-cors
    fetch(u, {mode: 'no-cors'})
      .then((response) => {
        console.log('setUserTags - done'+JSON.stringify(response));
        // if sessionStorage user_tags != true -> reload page & set user_tags = true
        window.location.reload();
        this.setSessionStorageWithExpiry('user_tags', 'true', 1);
      })
      .catch((error) => {
        console.log('setUserTags - error'+JSON.stringify(error));
      });

  }


  loadAll(delay=10) {
    const interval = setInterval(function () {
        window.dispatchEvent(new Event('loadall'));
    }, delay*1000);
  }

  logOut() {
    window.dispatchEvent(new Event('loadall'));
    const interval = setInterval(function () {
        const logoutUrl = '/account/logout';
        clearInterval(interval);
        window.location = logoutUrl;      
    }, 1000);
  }

  sessionTimeout() {    
    
      if (!document.getElementById('customerId')) return;      
      const idleDurationSecs = 1800; // X number of seconds 
      console.log('sessionTimeout enabled (' + idleDurationSecs + ' seconds)');

      const redirectUrl = '/account/logout'; // Redirect idle users to this URL
      let idleTimeout; // variable to hold the timeout, do not modify
      const resetIdleTimeout = function () {
        // Clears the existing timeout
        if (idleTimeout) clearTimeout(idleTimeout);

        // Set a new idle timeout to load the redirectUrl after idleDurationSecs
        idleTimeout = setTimeout(() => {
            na.logOut();
        }, idleDurationSecs * 1000);
      };

      // Init on page load
      resetIdleTimeout();

      // Reset the idle timeout on any of the events listed below
      ['click', 'touchstart', 'mousemove', 'keypress'].forEach((evt) =>
        document.addEventListener(evt, resetIdleTimeout, false)
      );
    
  }

  checkRedirectRequests() {
    var redirect_request = window.sessionStorage.getItem('redirect_request');
    var make_request = false;
    var limit = 300000;
    window.sessionStorage.removeItem('redirect_request');

    //only set redirect if not null and still valid request
    if (redirect_request != null) {
      var redirect_request_object = JSON.parse(redirect_request);
      if (
        new Date().getTime() - redirect_request_object.request_time < limit
      ) {
        make_request = true;
      }
    }
    console.log("make_request: ", make_request);

    //Make redirect
    if (make_request) {
        console.log("url: ",redirect_request_object.url )
        window.location = redirect_request_object.url;
    }
    return make_request;
  }

  hideCollectionsAll() {
    if (window.location.pathname === '/collections/all') {
      window.location = '/';
    }
  }
  
  // Add this function to handle cart attribute updates
  async updateCartAttribute(element, attributeName) {
    // Handle different input types
    let value = null;
    if (element) {
      value = element.type === 'checkbox' ? (element.checked ? 'kyllä' : 'ei') : element.value;
      if (value < 0) value = null;
    }
    
    try {
        const response = await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                attributes: {
                    [attributeName]: value
                }
            })
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        const data = await response.json();
        //console.log('Cart attribute updated:', data);
        
        // Only validate pharmaceutical selections if we're dealing with radio buttons
        if (element && element.type === 'radio') {
            this.validatePharmaceuticalSelections();
        }
    } catch (error) {
        console.error('Error updating cart attribute:', error);
        // Handle errors differently based on input type
        if (element.type === 'checkbox') {
            element.checked = !element.checked;
        } else if (element.type === 'radio') {
            element.checked = false;
        }
    }
  }
    
  validatePharmaceuticalSelections() {
    const pharmaceuticalSection = document.querySelector('.pharmaceutical-info-section');
    if (!pharmaceuticalSection) return true;

    const checkoutButton = document.getElementById('checkout');
    if (!checkoutButton) return true;

    let allSelected = true;
    
    // Check medical consultation selection
    const consultationSelected = document.querySelector('input[name="attributes[Haluan lääkeneuvontaa]"]:checked');
    if (!consultationSelected) {
        allSelected = false;
    }

    // Check age selection if the age section exists
    const ageSection = document.querySelector('input[name="attributes[Olen vähintään 18-vuotias]"]');
    if (ageSection && ageSection.type !== 'hidden' && !document.querySelector('input[name="attributes[Olen vähintään 18-vuotias]"]:checked')) {
        allSelected = false;
  }

    // Enable/disable checkout button
    checkoutButton.disabled = !allSelected;
  
    // Add visual feedback for required selections
    document.querySelectorAll('.radio-group[data-required="true"]').forEach(group => {
        if (!group.querySelector('input[type="radio"]:checked')) {
            group.classList.add('required-selection');
        } else {
            group.classList.remove('required-selection');
        }
    });

    return allSelected;
  }

  async setOrionStamps() {
    const st = document.getElementById("stamps-collected");
    if (st) {
      await this.updateCartAttribute(st, "Orionin keräilyleimoja");
    } else {
      await this.updateCartAttribute(null, "Orionin keräilyleimoja");
    }
  }
  
}


window.na = new NA();
na.sessionTimeout();

na.loadAll(10);

window.dispatchEvent(new Event('NAOk'));

document.addEventListener('click', function () {
  const _g = document.getElementsByClassName('giosg_shadow_dom');
  if (_g.length > 0) {
    _g[0].style.display = 'block';
  }
});


// Call the function when the page loads
// if currentURL.includes("#authenticated") -> setUserTags()
window.addEventListener("load", function() {
      var currentURL = window.location.href;
      //if (currentURL.includes("#authenticated")) {
      if (currentURL.includes("#authentication-done")) {
          window.na.setUserTags();
      }
     window.na.hideCollectionsAll();
     window.na.checkRedirectRequests();
     window.na.updateCartAttribute(null, "Orionin keräilyleimoja");
});


